module.exports = __webpack_public_path__ + "assets/a0ef1404dff9b3921c8ee1d22c49d62c.mp3";